import useStore from '../../../sharedCode/stores/store';
import useDndStore from '../../../sharedCode/stores/dndStore';
import { handleActiveTabMove } from '../../../platformFiles/extensionSpecific/handleActiveTabMove';
import { handleGroupMove } from './handleGroupMove';
import { handleTabMove } from './handleTabMove';

const resetStates = useDndStore.getState().resetStates;

export const handleDragEnd = (active, over, isShiftKeyPressed) => {
    let isActiveTab = active?.data?.current?.isActiveTab;
    // let hideDragIds = {};
    // useDndStore.getState().dragIds.forEach((id) => {
    //     hideDragIds[id] = true;
    // });
    // useDndStore.setState({ hideDragIds: hideDragIds });
    let activeItem = useDndStore.getState().activeItem;
    if (
        (active?.data?.current?.type === 'tab' && !isActiveTab) ||
        (activeItem?.dragType === 'tab' && !isActiveTab)
    ) {
        handleTabMove(active, isShiftKeyPressed);
    } else if (active?.data?.current?.type === 'tab' && isActiveTab) {
        handleActiveTabMove(active, isShiftKeyPressed);
    } else if (active?.data?.current?.type === 'dragGroup') {
        handleGroupMove(active, over);
    }
    resetStates();
};

const moveTabToActive = () => {};

const moveTabFromActive = () => {};

const rearrangeActiveTab = () => {};
